module.exports = __webpack_public_path__ + "img/addFood2.d9541615.png";